module.exports = __webpack_public_path__ + "static/media/52569195_2452989884776188_3241334006368698368_o.6359feb3.jpg";